import { inject, Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import OcConfigSvc from "./ocConfigSvc";
import { saveAs } from "file-saver";
import { UtilityService } from "./utils.service";
interface IHTTPOptions {
  observe: string;
  headers?: HttpHeaders;
}

@Injectable({
  providedIn: "root",
})
export class APIService {
  bearer: string;
  private httpClient = inject(HttpClient);
  constructor(
    protected ocConfigSvc: OcConfigSvc,
    public _utilityService: UtilityService
  ) {}
  getCredentials() {
    var credentialsObject = JSON.parse(
      localStorage.getItem("DesktopCredentialData")
    );
    if (credentialsObject) {
      this.bearer = credentialsObject.token;
    }
    const headers = new HttpHeaders()
      .append("ContentType", "application/json; charset=utf-8")
      .append("Authorization", this.bearer)
      .append("OcClientId", this.ocConfigSvc.user.client.id)
      .append("OcSiteId", this.ocConfigSvc.user?.site.id);
    return headers;
  }
  getExportCredentials() {
    var credentialsObject = JSON.parse(
      localStorage.getItem("DesktopCredentialData")
    );
    if (credentialsObject) {
      this.bearer = credentialsObject.token;
    }
    const headers = new HttpHeaders()
      .append("Authorization", this.bearer)
      .append("OcClientId", this.ocConfigSvc.user.client.id)
      .append("OcSiteId", this.ocConfigSvc.user?.site.id);
    return headers;
  }
  getDeleteCredentials() {
    var credentialsObject = JSON.parse(
      localStorage.getItem("DesktopCredentialData")
    );
    if (credentialsObject) {
      this.bearer = credentialsObject.token;
    }
    const headers = new HttpHeaders()
      .append("Authorization", this.bearer)
      .append("OcClientId", this.ocConfigSvc.user.client.id)
      .append("OcSiteId", this.ocConfigSvc.user?.site.id)
      .append("Content-Type", "application/json");

    return headers;
  }

  fetchData(url: string, params: any, credentials?: boolean) {
    if (credentials) {
      var headers = this.getCredentials();
      return this.httpClient
        .get(url, { params, headers: headers, observe: "response" })
        .pipe(map((resData) => resData.body));
    }
    return this.httpClient
      .get(url, { params, observe: "response" })
      .pipe(map((resData) => resData.body));
  }
  postData(url, params: any) {
    var headers = this.getCredentials();
    return this.httpClient
      .post(url, params, {
        headers: headers,
        observe: "response",
      })
      .pipe(map((resData) => resData.body));
  }
  postExportData(url, params: any) {
    var config = {
      data: "",
      responseType: "arraybuffer",
    };
    var headers = this.getExportCredentials();
    return this.httpClient
      .post(url, params, {
        headers: headers,
        observe: "response",
        responseType: "arraybuffer",
      })
      .pipe(
        map((resData) => {
          if (resData.body) {
            var fileName = this._utilityService.getFileNameFromHeader(
              'attachment; filename="End of Month Search.csv"'
            );
            var type = "application/vnd.ms-excel";
            var text = new Blob([resData.body], {
              type: type,
            });
            saveAs(text, fileName);
          }
        })
      );
  }
  deleteData(url, params: any) {
    var headers = this.getDeleteCredentials();
    return this.httpClient
      .delete(url, { body: params, headers: headers, observe: "response" })
      .pipe(map((resData) => resData.body));
  }
}
